import React, {useEffect, useContext} from 'react'
import "./login.css"
import forImg from "./images/heaphone.png"
import axios from "axios"
import {useNavigate} from 'react-router-dom'
import { Context1 } from '../../utils/auth'



function Login() {
    
    
    const {user, setGAuth, name, setName, email, setEmail, password, setPassword, handleRegisterSubmit, handleLoginSubmit} =
    useContext(Context1);
    
    const navigate = useNavigate();
    if (user===true) {
        navigate("/");
    }
    
    const googleAuth = () => {
		window.open(
			`${process.env.REACT_APP_API}/auth/google/callback`,
			"_self"
		);
	};

	const getUser = async () => {
		try {
			const url = `${process.env.REACT_APP_API}/auth/login/success`;
			const { data } = await axios?.get(url, { withCredentials: true });
            setGAuth(true);
            navigate("/")
		} catch (err) {
			console.log(err);
		}
	};


	useEffect(() => {
        getUser();
    }, []);

  return (
    <>
        <section className="main-container">
            <div className="main-content">
                <div className="left-content">
                    <div className="message">
                        <div className="landing-head">
                            <svg viewBox="0 0 1320 300">
                                <text x="50%" y="50%" dy=".35em" textAnchor="middle">
                                    Xiel Store
                                </text>
                            </svg>
                        </div>
                        <div className="landing-message">
                            <h2 className='landing-h2'>Your one-stop destination for all things audio.</h2>
                            <p className='landing-p'>Elevate Your Audio Experience <br /> Shop Headphones, Speakers & AirPods</p>
                        </div>
                    </div>
                    <div className="for-img">
                        <img src={forImg} alt="" className='for-image-main'/>
                    </div>
                </div>
                <div className="right-content">
                    <svg className='mobile-signup-animation' viewBox="0 0 1320 300">
                        <text x="50%" y="50%" dy=".35em" textAnchor="middle">
                            Xiel Store
                        </text>
                    </svg>
                    <div className="login-main">  	
		                <input className='input' type="checkbox" id="chk" aria-hidden="true" />
                        <div className="signup">
                            <form onSubmit={handleRegisterSubmit}>
                                <label className='label label-sign-up' htmlFor="chk" aria-hidden="true" >Sign up</label>
                                <input className='input' value={name} onChange={(e) => setName(e.target.value)} type="text" name="txt" placeholder="User name"  required/>
                                <input className='input' value={email} onChange={(e) => setEmail(e.target.value)} type="email" name="email" placeholder="Email"  required/>
                                <input className='input' value={password} onChange={(e) => setPassword(e.target.value)} type="password" name="pswd" placeholder="Password"  required/>
                                <button className='sign-up-btn'>Sign up</button>
                                <div className="sign-up-go google">
                                    <div className="go" onClick={() => googleAuth()}><i className="fab fa-google"></i>  Google</div>
                                </div>
                            </form>
                        </div>
                        <div className="login">
                            <form onSubmit={handleLoginSubmit}>
                                <label className='label' htmlFor="chk" aria-hidden="true">Login</label>
                                <input className='input' value={email} onChange={(e) => setEmail(e.target.value)} type="email" name="email" placeholder="Email"  required/>
                                <input className='input' value={password} onChange={(e) => setPassword(e.target.value)} type="password" name="pswd" placeholder="Password"  required/>
                                <button className='sign-up-btn'>Login</button>
                                <div className="sign-up-go">
                                    <div className="go" id='log-in-go'><i className="fab fa-google" style={{paddingRight: "5px"}}></i>Google</div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Login;
